import { axiosCore } from './http-core-service';
import { RelevesDto } from './dtos/releves.dto';

/**
 * Appel API récupérant les releves
 * @param contractId Contrat dont les factures sont à récupérer
 * @param page
 * @param rowsPerPage
 * @param sort tri des éléments
 */
export const getReleves = async (
    contractId: string | undefined,
    page: number,
    rowsPerPage: number,
    sort?: string
): Promise<RelevesDto> => {
    const response = await axiosCore.get(
        `/rattachement_contrats/${contractId}/releves?page=${page}&itemsPerPage=${rowsPerPage}&pagination=true` + sort
    );
    return {
        releves: response.data.data,
        totalItems: response.data.pagination.totalItems,
    };
};
